import { Component } from '@angular/core';

import NumberUtils from '../../../utils/number.utils'
import { StringDateNoTimePipe } from "../../../ui-helper/string-date-no-time.pipe";
import { ReportJobService } from "../../../ui-helper/download-status/report-job.service";

@Component({
	template: `
		<bo-reporting-list-presentation
				(vvkSteAbrClicked)="downloadVvkSteAbrechnung($event)"
		></bo-reporting-list-presentation>
	`,
})
export class BookingOfficeReportingListComponent {
	constructor(
		private dateNoTimePipe: StringDateNoTimePipe,
		private reportJobStatusService: ReportJobService
	) {
	}

	downloadVvkSteAbrechnung(data) {
		const filename = `Vorverkaufsstellenabrechnung_${this.dateNoTimePipe.transform(data.from, null)}-\
${this.dateNoTimePipe.transform(data.to, null)}.xlsx`
		const reportSubtitle = this.dateNoTimePipe.transform(data.from, null) + " - " +
			this.dateNoTimePipe.transform(data.to, null) + ", Abrechnungssatz: " + data.abrechnungsSatz + "%";

		const queryString = `?fromDate=${data.from}&toDate=${data.to}&share=${NumberUtils.parseNumber(data.abrechnungsSatz)}`;
		this.reportJobStatusService.queueReportJob(true, "VORVERKAUFSSTELLENABRECHNUNG", filename, queryString, reportSubtitle);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/reporting/bo-reporting-list/bo-reporting-list.component.ts